import { toast } from 'react-toastify';
import APIs from '../../apiUrl';

const getProfile = async () => {
  try {
    const response = await APIs.get(`/get_admin_user`);

    if (response?.data?.message === 'success') {
      // toast('User Data Successful');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const editAdmin = async (payload) => {
  try {
    const response = await APIs.patch(`/admin_edit_user`, payload);

    if (response?.data?.message === 'success') {
      toast('successfully edited');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const editAdminPassword = async (payload) => {
  try {
    const response = await APIs.patch(`/admin_edit_user_password`, payload);

    if (response?.data?.message === 'success') {
      toast('successfully edited');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const editAdminProfilePic = async (payload) => {
  try {
    const response = await APIs.patch(`/admin_update_profile`, payload);

    if (response?.data?.message === 'success') {
      toast('successfully edited');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const profileService = {
  editAdmin,
  getProfile,
  editAdminProfilePic,
  editAdminPassword,
};

export default profileService;
